import Vue from 'vue';
import VueRouter from 'vue-router';

import LoginPage from '../views/Login';
// import DashboardPage from '../views/Dashboard';
import MemberList from '../views/Member/MemberList';
import AdminList from '../views/admin/AdminList';
import Master from '../views/Master/Master';
import PointBulkRegistration from '../views/Point/PointBulkRegistration';
import LoginAdmin from '../views/admin/LoginAdminView';
import ReserveListByDay from '../views/Reserve/ReserveListByDay';
import ReserveListByMonth from '../views/Reserve/ReserveListByMonth';
import ReserveListByConditions from '../views/Reserve/ReserveListByConditions';
import ReserveRequestList from '../views/Reserve/ReserveRequestList';
import PlanList from '../views/Plan/PlanList.vue';
import planMaster from '../views/Plan/PlanMaster.vue';
import PlayTimeSetting from '../views/Plan/PlayTimeSetting';
import System from '../views/System/System';
import ChatBox from '../views/Member/ChatBox';
import DeliverySetting from '../views/Delivery/DeliverySetting';
import DeliveryMessage from '../views/Delivery/DeliveryMessage';
import DeliveryResults from '../views/Delivery/DeliveryResults';
// import PointManage from '../views/Point/PointManage';    // 2020/03/06 ポイント倍率設定機能廃止
// import BackbonesystemLogList from '../views/BackbonesystemLog/BackbonesystemLogList';   // 2020/03/06 基幹システム連携結果機能廃止
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'memberList',
        component: MemberList,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage
    },
    {
        path: '/admin',
        name: 'AdminList',
        component: AdminList,
        meta: { requiresAuth: true }
    },
    {
        path: '/master',
        name: 'Master',
        component: Master,
        meta: { requiresAuth: true }
    },
    {
        path: '/pointBulkRegistration',
        name: 'PointBulkRegistration',
        component: PointBulkRegistration,
        meta: { requiresAuth: true }
    },
    {
        path: '/loginAdmin',
        name: 'LoginAdmin',
        component: LoginAdmin,
        meta: { requiresAuth: true }
    },
    {
        path: '/reserveListByDay',
        name: 'ReserveListByDay',
        component: ReserveListByDay,
        meta: { requiresAuth: true }
    },
    {
        path: '/reserveListByMonth',
        name: 'ReserveListByMonth',
        component: ReserveListByMonth,
        meta: { requiresAuth: true }
    },
    {
        path: '/reserveRequest',
        name: 'ReserveRequestList',
        component: ReserveRequestList,
        meta: { requiresAuth: true }
    },
    {
        path: '/reserveListByConditions',
        name: 'ReserveListByConditions',
        component: ReserveListByConditions,
        meta: { requiresAuth: true }
    },
    {
        path: '/planlist',
        name: 'PlanList',
        component: PlanList,
        meta: { requiresAuth: true }
    },
    {
        path: '/planMaster',
        name: 'planMaster',
        component: planMaster,
        meta: { requiresAuth: true }
    },
    {
        path: '/startTime',
        name: 'PlayTimeSetting',
        component: PlayTimeSetting,
        meta: { requiresAuth: true }
    },
    {
        path: '/system',
        name: 'System',
        component: System,
        meta: { requiresAuth: true }
    },
    {
        path: '/chatBox',
        name: 'ChatBox',
        component: ChatBox,
        meta: { requiresAuth: true }
    },
    {
        path: '/deliverySetting',
        name: 'DeliverySetting',
        component: DeliverySetting,
        meta: { requiresAuth: true }
    },
    {
        path: '/deliveryMessage',
        name: 'DeliveryMessage',
        component: DeliveryMessage,
        meta: { requiresAuth: true }
    },
    {
        path: '/deliveryResults',
        name: 'DeliveryResults',
        component: DeliveryResults,
        meta: { requiresAuth: true }
    }
    // 2020/03/06 ポイント倍率設定機能廃止
    // {
    //     path: '/point',
    //     name: 'point',
    //     component: PointManage,
    //     meta: { requiresAuth: true }
    // },
    // 2020/03/06 基幹システム連携結果機能廃止
    // {
    //     path: '/backbonesystemLog',
    //     name: 'backbonesystemLog',
    //     component: BackbonesystemLogList,
    //     meta: { requiresAuth: true }
    // }
    // {
    //     path: '/about',
    //     name: 'about',
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// ルーティング前の処理を差し込む
router.beforeEach(async (to, from, next) => {
    store.commit('loading/setIsLoading', true);
    if (to.matched.some(record => record.meta.requiresAuth)) {
        await store.dispatch('auth/getLoginAdmin');
        if (!store.state.auth.loginAdmin) {
            next('/login');
        }
        await store.dispatch('auth/getMessageCount');
    }
    next();
});

// ルーティング後の処理
router.afterEach(() => {
    store.dispatch('auth/getMessageCount');
    // loading画面終了
    store.commit('loading/setIsLoading', false);
});

export default router;
